import { ClientUserConstants as Constants } from '../../types'

const initialState = {
    users: [],


};

export function userReducer(state = initialState, action) {
    switch (action.type) {  
        case Constants.GET:            
            return {
                ...state,
                users: action?.payload?.users,                
            };

   
            
        case Constants.ADD:
            return {
                ...state,
                users: [...state?.users, action?.payload?.user]
            }

        case Constants.UPDATE:            
            const index = state.users.findIndex(x => parseInt(x.id) ===  parseInt(action?.payload?.user?.id))
            const newArray = [...state.users];
            if(index > -1)
                newArray[index] = action?.payload?.user
            return {
                ...state,
                users: newArray                
            }   

        case Constants.DELETE:
            return{
                ...state,
                users: state?.users?.filter(x => parseInt(x?.id) !== parseInt(action?.payload?.id))                
            };
       
        
        case Constants.FAIL:
            return{
                ...state,
                error: action?.error
            }
        
        case Constants.LOADING:
            return{
                ...state,
                error: null
            }

        case Constants.CLEAR:
            return{
                ...state,
                users: []
            }
        default:
            return state
    }
}